import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "successAlert",
    "submitBtn",
    "name",
    "email",
    "link",
    "format",
    "audience",
    "budget",
    "notes"
  ];

  sentRequest() {
    this.clearErrors();
    let hasError = false;

    hasError |= this.validateRequired(this.nameTarget, "Name is required");
    hasError |= this.validateRequired(this.audienceTarget, "Target region is required");
    hasError |= this.validateRequired(this.budgetTarget, "Budget is required");
    hasError |= this.validateRequired(this.formatTarget, "Please select ad format");
    hasError |= this.validateRequired(this.linkTarget, "Website is required");

    const email = this.emailTarget.value.trim();
    if (!email) {
      this.showError(this.emailTarget, "Email is required");
      hasError = true;
    } else if (!this.isValidEmail(email)) {
      this.showError(this.emailTarget, "Invalid email format");
      hasError = true;
    }

    if (this.linkTarget.value.trim() && !this.isValidUrl(this.linkTarget.value.trim())) {
      this.showError(this.linkTarget, "Invalid URL");
      hasError = true;
    }

    const message = this.notesTarget.value.trim();
    if (message.length > 500) {
      this.showError(this.notesTarget, "Message must be 500 characters or less");
      hasError = true;
    }

    if (hasError) return;

    const payload = {
      name: this.nameTarget.value.trim(),
      email: email,
      website: this.linkTarget.value.trim(),
      ad_format: this.formatTarget.value,
      target_region: this.audienceTarget.value.trim(),
      budget: this.budgetTarget.value.trim(),
      message: message || null
    };

    this.send(payload);
  }


  async send(payload) {
    try {
      this.submitBtnTarget.disabled = true;
      const response = await fetch("/advertise-with-us/send-request", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      this.resetForm();
      this.successAlertTarget.classList.remove("d-none");

      setTimeout(() => {
        this.successAlertTarget.classList.add("d-none");
      }, 3000);

    } catch (error) {
      console.error("Send error:", error);
    } finally {
      this.submitBtnTarget.disabled = false;
    }
  }

  validateRequired(element, message) {
    if (!element.value || !element.value.trim()) {
      this.showError(element, message);
      return true;
    }
    return false;
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  showError(element, message) {
    element.classList.add("is-invalid");

    let feedback = element.nextElementSibling;

    if (!feedback || !feedback.classList.contains("invalid-feedback")) {
      feedback = document.createElement("div");
      feedback.className = "invalid-feedback";
      element.after(feedback);
    }

    feedback.textContent = message;
  }

  clearErrors() {
    this.element
      .querySelectorAll(".is-invalid")
      .forEach(el => el.classList.remove("is-invalid"));

    this.element
      .querySelectorAll(".invalid-feedback")
      .forEach(el => el.remove());
  }
  resetForm() {
    this.nameTarget.value = "";
    this.emailTarget.value = "";
    this.linkTarget.value = "";
    this.formatTarget.value = "";
    this.audienceTarget.value = "";
    this.budgetTarget.value = "";
    this.notesTarget.value = "";
  }
  selectClass(){
    if (this.formatTarget.value !== ""){
      this.formatTarget.classList.remove("text-gray")
    } else {
      this.formatTarget.classList.add("text-gray")
    }
  }
}
